// https://github.com/chakra-ui/chakra-ui/tree/master/packages/chakra-ui/src/theme
import { Theme, theme } from '@chakra-ui/react';

interface CustomTheme {
  colors: {
    primaryRed: string;
    darkBlue: {
      50: string;
      100: string;
      200: string;
      300: string;
      400: string;
      500: string;
      600: string;
      700: string;
      800: string;
      900: string;
    };
    primaryDarkBlue: string;
    hoveredDarkBlue: string;
    bgGray: string;
  };
}

export const customTheme: Theme & CustomTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    primaryRed: '#EB4458',
    darkBlue: {
      50: '#eaf3fe',
      100: '#ccd9e7',
      200: '#adbfd2',
      300: '#8da6bf',
      400: '#6e8cac',
      500: '#394867', //colorSchemeのみの指定を可能にするため500の色を調整
      600: '#405972',
      700: '#394867',
      800: '#192633',
      900: '#010e16',
    },
    primaryDarkBlue: '#394867',
    hoveredDarkBlue: '#1B2C3E',
    bgGray: '#F7FAFC',
  },
  styles: {
    global: {
      body: {
        margin: 0,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        border: 0,
      },
      ul: {
        listStyle: 'none',
      },
      'html, body, #root': {
        height: '100%',
      },
      '*, ::before, ::after': {
        borderWidth: '0px',
        borderStyle: 'solid',
        borderColor: 'rgb(226, 232, 240)',
      },
    },
  },
};
